import _ from 'lodash'

import { Thesaurus } from '@skinsoft/types'
import { OfflineDataFetcher } from '@skinsoft/offline'

export class ThesaurusOfflineDataFetcher extends OfflineDataFetcher<Thesaurus>{

    constructor(cacheKey: string) {
        super(cacheKey);
    }

    protected idMatcher(entity: any, id: string) {
        if (entity.thesaurusCS) {
            return entity.thesaurusCS.identifier === id;
        }
        return _.get(entity, 'thesaurusCS.identifier') || false;
    }

}